export default "__VITE_ASSET__CijuFKlk__"